// External
import _ from "lodash";
import React from "react";
import withDerivedProps from "lib/withDerivedProps";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";

// Design system
import { Dropdown, DropdownMenu, FilterLabelButton } from "@toddle-edu/ds-web";

// Utils
import { AI_TRANSLATION_LANGUAGES } from "@toddle-edu/common-utils";

// Modules
import { updateSettings } from "modules/ConfigurationThunks";
import { getSettingValue } from "Utils/ConfigurationUtils";

// Components
import UIBaseComponent from "UIComponents/UIBaseComponent";

// Scss
import classes from "./FieldAIEvaluationLanguage.scss";

const styles = {
  containerStyle: {
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
  },
  labelContainerStyle: {
    width: "fit-content",
    marginBottom: "0px",
  },
};

const getAITranslationDropdownOptions = () => {
  return _.map(AI_TRANSLATION_LANGUAGES, language => {
    const { id, label, code } = language;
    return {
      key: _.toString(id),
      label,
      lng: code,
      value: code,
    };
  });
};

class FieldAIEvaluationLanguage extends UIBaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      isDisableAIEvaluationWarningModalOpen: false,
    };
  }

  getAIEvaluationLanguage = () => {
    const { value, i18n, defaultLanguagePreferenceId } = this.props;

    const platformLanguage = _.get(i18n, "language", "en");
    const aiTranslationLanguages = getAITranslationDropdownOptions();

    return (
      _.find(aiTranslationLanguages, language => {
        // if user has selected a language, use that
        if (!_.isEmpty(value)) {
          return _.get(language, "key") === value;
        } else if (!_.isEmpty(defaultLanguagePreferenceId)) {
          return _.get(language, "key") === defaultLanguagePreferenceId;
        }

        if (platformLanguage === "en-US") {
          return _.get(language, "key") === "9";
        } else if (platformLanguage === "en-GB") {
          return _.get(language, "key") === "10";
        }

        // else use the platform language
        return _.get(language, "lng") === platformLanguage;
      }) || {}
    );
  };

  // value will always be null as this component is just to show label and language selector
  shouldShowEmpty = () => false;

  renderLanguageSelector = ({ disabled }) => {
    const { updateInputField, fieldKey, updateSettings } = this.props;

    const { key, label: languageLabel } = this.getAIEvaluationLanguage();
    const aiTranslationLanguages = getAITranslationDropdownOptions();

    const onClickDropdownOption = option => {
      updateInputField(
        {
          [fieldKey]: option?.key,
        },
        undefined,
        true,
        true,
        false
      );

      updateSettings({
        settings: [
          {
            name: "ConfigureAIGradingVoiceLanguage",
            value: JSON.stringify(option?.key),
          },
        ],
        showToastMsg: false,
      });
    };

    return (
      <Dropdown
        overlay={
          <DropdownMenu
            isSearchEnabled
            showSelection={true}
            value={key}
            options={aiTranslationLanguages}
            onClick={onClickDropdownOption}
          />
        }
        disabled={disabled}
        size="small"
        dsVersion="2.0"
      >
        <FilterLabelButton
          variant="neutral"
          type="outlined"
          dsVersion="2.0"
          size="medium"
          labelValue={languageLabel}
          disabled={disabled}
        />
      </Dropdown>
    );
  };

  renderView = () => {
    return (
      <div className={classes.container}>
        {this.renderLanguageSelector({ disabled: true })}
      </div>
    );
  };

  renderEdit = () => {
    return (
      <div className={classes.container}>
        {this.renderLanguageSelector({ disabled: false })}
      </div>
    );
  };
}

const getDerivedProps = () => {
  let defaultLanguagePreferenceId;

  // if setting value contains "" then getSettingsValue can throw error
  try {
    defaultLanguagePreferenceId = getSettingValue({
      name: "ConfigureAIGradingVoiceLanguage",
      readFromUserAndOrgLevel: true,
    });
  } catch (err) {
    defaultLanguagePreferenceId = null;
  }

  return {
    defaultLanguagePreferenceId,
    containerStyle: styles.containerStyle,
    labelContainerStyle: styles.labelContainerStyle,
  };
};

const mapActionCreators = {
  updateSettings,
};

export default compose(
  connect(null, mapActionCreators),
  withDerivedProps(getDerivedProps)
)(FieldAIEvaluationLanguage);
